import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
selector: '[appSanitizeInput]',
})
export class SanitizeInputDirective {

constructor(private el: ElementRef) {}

// Listen for the 'input' event
@HostListener('input', ['$event']) onInput(event: Event): void {
this.sanitize();
}

// Listen for the 'paste' event
@HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
event.preventDefault(); // Stop the default paste
const pastedText = event.clipboardData?.getData('text/plain') || '';
// Sanitize the pasted text before inserting it
document.execCommand('insertText', false, this.stripTags(pastedText));
}

private sanitize(): void {
const initialValue = this.el.nativeElement.value;
const sanitizedValue = this.stripTags(initialValue);
if (initialValue !== sanitizedValue) {
this.el.nativeElement.value = sanitizedValue;
// Emit an input event to update the form control
this.el.nativeElement.dispatchEvent(new Event('input'));
}
}

private stripTags(html: string): string {
// A more robust method: use the DOM parser to extract text content
const doc = new DOMParser().parseFromString(html, 'text/html');
return doc.body.textContent || '';
}
}